import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import {
  PriorityEnum,
  priorityEnumMapping
} from '../../../lib/types/enums/staff-application/priority.enum'
import { StaffApplicationPriorityInput } from '../../../lib/types/models/staff-application/staff-application-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { getSelectedOption } from '../../../lib/utils/functions/misc.functions'
import { createEnumSchema } from '../../../lib/utils/validations/enum-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledSelectInput from '../../elements/inputs/controlled-select-input'
import ValidationButtons from '../../elements/validation-buttons'

const formSchema: ZodType<StaffApplicationPriorityInput> = z.object({
  priority: createEnumSchema({ fieldName: 'priorité', enumType: PriorityEnum })
})

type StaffApplicationPriorityFormProps = BaseFormProps<StaffApplicationPriorityInput> & {
  className?: string
}

const StaffApplicationPriorityForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: StaffApplicationPriorityFormProps) => {
  const form = useForm<StaffApplicationPriorityInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex flex-col gap-4', className)}>
          <FormField
            control={form.control}
            name="priority"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledSelectInput<PriorityEnum>
                    options={Object.values(PriorityEnum).map((priority) => ({
                      label: priorityEnumMapping[priority].label,
                      value: priority
                    }))}
                    dropDownPosition="above"
                    label={'Priorité'}
                    selectedOption={getSelectedOption(
                      field.value,
                      priorityEnumMapping[field.value].label
                    )}
                    onChange={(value) =>
                      form.setValue('priority', value, { shouldValidate: true })
                    }
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default StaffApplicationPriorityForm
